import Loader from './loader.container';

export default Loader;
